export const specialtiesAndTreatmentModalities = [
  { label: 'Adolescent Therapy', value: 'Adolescent Therapy' },
  { label: 'Anger Management', value: 'Anger Management' },
  { label: 'Art and Music Therapy', value: 'Art and Music Therapy' },
  { label: 'Attachment-based Therapy', value: 'Attachment-based Therapy' },
  { label: 'Biofeedback', value: 'Biofeedback' },
  { label: 'BrainSpotting', value: 'BrainSpotting' },
  { label: 'Child Therapy', value: 'Child Therapy' },
  { label: 'Cognitive Behavioral Therapy (CBT)', value: 'Cognitive Behavioral Therapy (CBT)' },
  { label: 'Couples Therapy', value: 'Couples Therapy' },
  { label: 'Cultural Identity', value: 'Cultural Identity' },
  { label: 'Dialectical Behavior Therapy (DBT)', value: 'Dialectical Behavior Therapy (DBT)' },
  { label: 'Eating Disorders', value: 'Eating Disorders' },
  { label: 'EMDR', value: 'EMDR' },
  { label: 'Faith-Based or Spiritual Counseling', value: 'Faith-Based or Spiritual Counseling' },
  { label: 'Geriatric Therapy', value: 'Geriatric Therapy' },
  { label: 'Grief and Loss', value: 'Grief and Loss' },
  { label: 'Group Therapy', value: 'Group Therapy' },
  { label: 'In Vitro Fertilization Assessments', value: 'In Vitro Fertilization Assessments' },
  { label: 'Internal Family Systems Therapy (IFS)', value: 'Internal Family Systems Therapy (IFS)' },
  { label: 'Ketamine-Assisted Therapy', value: 'Ketamine-Assisted Therapy' },
  { label: 'LGBTQIA+', value: 'LGBTQIA+' },
  { label: 'Marginalized Groups (BIPOC)', value: 'Marginalized Groups (BIPOC)' },
  { label: 'Medication Management', value: 'Medication Management' },
  { label: "Men's Issues", value: "Men's Issues" },
  { label: 'Mindfulness', value: 'Mindfulness' },
  { label: 'Mood Disorders', value: 'Mood Disorders' },
  { label: 'Narcissistic Abuse', value: 'Narcissistic Abuse' },
  { label: 'Neurodivergence', value: 'Neurodivergence' },
  { label: 'Neurofeedback', value: 'Neurofeedback' },
  { label: 'Obsessive-Compulsive Disorder (OCD)', value: 'Obsessive-Compulsive Disorder (OCD)' },
  { label: 'Parenting', value: 'Parenting' },
  { label: 'Personality Disorders', value: 'Personality Disorders' },
  { label: 'Psychological Testing', value: 'Psychological Testing' },
  { label: 'Relationships Issues', value: 'Relationships Issues' },
  { label: 'Self-Harm', value: 'Self-Harm' },
  { label: 'Sex Therapy', value: 'Sex Therapy' },
  { label: 'Solution-Focused Brief Therapy', value: 'Solution-Focused Brief Therapy' },
  { label: 'Sports Therapy', value: 'Sports Therapy' },
  { label: 'Testing and Evaluation', value: 'Testing and Evaluation' },
  { label: 'Transitional Age Youth (TAY)', value: 'Transitional Age Youth (TAY)' },
  { label: 'Veterans Therapy', value: 'Veterans Therapy' },
  { label: 'Trauma-Focused Therapy', value: 'Trauma-Focused Therapy' },
  { label: 'Substance Use and Addiction', value: 'Substance Use and Addiction' },
  { label: 'Somatic Therapy', value: 'Somatic Therapy' },
  { label: 'Not Listed', value: 'Not Listed' },
];
